module.exports = __webpack_public_path__ + "static/media/twitter-brands.e86b218c.svg";